module.exports = __webpack_public_path__ + "Assets/Images/createPage/zoho-old.svg";